module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      loading: _vm.loading
    }
  }, [(_vm.client && _vm.client.id) ? _c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_vm._t("toolbar-icon", function() {
    return [(_vm.withPrevNext) ? _c('v-toolbar-side-icon', [_c('v-btn', {
      attrs: {
        "icon": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.$emit("prev")
        }
      }
    }, [_c('v-icon', [_vm._v("arrow_left")])], 1)], 1) : _vm._e()]
  }), _vm._v(" "), _c('v-toolbar-title', [_vm._t("header", function() {
    return [(_vm.withClientPreview && _vm.relationshipId) ? _c('v-menu', {
      attrs: {
        "close-on-content-click": false,
        "nudge-width": 200,
        "offset-x": ""
      },
      model: {
        value: (_vm.clientPreviewMenu),
        callback: function($$v) {
          _vm.clientPreviewMenu = $$v
        },
        expression: "clientPreviewMenu"
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "icon": ""
      },
      slot: "activator"
    }, [(_vm.clientPreviewMenu) ? _c('v-icon', {
      staticClass: "mr-2"
    }, [_vm._v("visibility_off")]) : _c('v-icon', {
      staticClass: "mr-2"
    }, [_vm._v("visibility")])], 1), _vm._v(" "), _c('v-card', {
      attrs: {
        "min-width": 280
      }
    }, [_c('client-card', {
      attrs: {
        "relationship-id": _vm.relationshipId
      }
    })], 1)], 1) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.normalizedClient.first_name) + " " + _vm._s(_vm.normalizedClient.last_name) + ".\n      ")]
  }), _vm._v(" "), _vm._t("subheader")], 2), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _vm._t("toolbar-buttons"), _vm._v(" "), (_vm.withFilters) ? _c('filters', {
    attrs: {
      "statement": _vm.statement,
      "with-actions": true,
      "filter-from-date": _vm.filterFromDate,
      "filter-to-date": _vm.filterToDate,
      "filter-status-ids": _vm.filterStatusIds,
      "touch-show": _vm.filterTouch
    },
    on: {
      "filters:string": _vm.setFilterString,
      "filters:params": _vm.setFilters
    },
    model: {
      value: (_vm.filters),
      callback: function($$v) {
        _vm.filters = $$v
      },
      expression: "filters"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.withReload) ? _c('v-btn', {
    attrs: {
      "loading": _vm.loading,
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("reload", this.filters)
      }
    }
  }, [_c('v-icon', [_vm._v("replay")])], 1) : _vm._e(), _vm._v(" "), (_vm.withPrevNext) ? _c('v-btn', {
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("next")
      }
    }
  }, [_c('v-icon', [_vm._v("arrow_right")])], 1) : _vm._e(), _vm._v(" "), (_vm.withFilters) ? _c('span', {
    staticClass: "py-0 my-0",
    attrs: {
      "slot": "extension"
    },
    slot: "extension"
  }, [(_vm.filterString) ? _c('span', [_vm._v(_vm._s(_vm.filterString))]) : _vm._e(), _vm._v(" "), (!_vm.filterString && _vm.initialFilterText) ? _c('span', [_vm._v(_vm._s(_vm.initialFilterText))]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "hidden-xs-only",
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        _vm.filterTouch++
      }
    }
  }, [_vm._v("Edit")]), _vm._v(" "), _c('v-btn', {
    staticClass: "hidden-xs-only",
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": _vm.clearFilters
    }
  }, [_vm._v("Clear")])], 1) : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-list', {
    staticClass: "pa-0",
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile', {
    staticClass: "no-pad-left",
    on: {
      "click": function($event) {
        _vm.selectAll = !_vm.selectAll
      }
    }
  }, [_c('v-list-tile-action', {
    staticClass: "grey lighten-4",
    staticStyle: {
      "min-width": "30px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAll),
      expression: "selectAll"
    }],
    staticClass: "ml-2",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAll) ? _vm._i(_vm.selectAll, null) > -1 : (_vm.selectAll)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.selectAll,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAll = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectAll = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAll = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('v-divider', {
    staticClass: "mr-2",
    attrs: {
      "vertical": ""
    }
  }), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Select all")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "px-0 py-0"
  }, [_c('v-divider'), _vm._v(" "), (_vm.appointments && _vm.appointments.length > 0) ? _c('v-expansion-panel', {
    staticClass: "dense elevation-0",
    attrs: {
      "expand": ""
    },
    model: {
      value: (_vm.panelState),
      callback: function($$v) {
        _vm.panelState = $$v
      },
      expression: "panelState"
    }
  }, _vm._l((_vm.appointments), function(appointment, index) {
    return _c('v-expansion-panel-content', {
      key: index
    }, [_c('div', {
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [_c('v-layout', [_c('v-flex', {
      staticStyle: {
        "width": "70%"
      }
    }, [_c('v-list-tile', {
      staticClass: "no-pad-left pl-0"
    }, [_c('v-list-tile-action', {
      staticClass: "grey lighten-4",
      staticStyle: {
        "min-width": "30px"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.noop.apply(null, arguments)
        }
      }
    }, [(_vm.withSelectable && appointment) ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.selectedAppointmentIds),
        expression: "selectedAppointmentIds"
      }],
      staticClass: "ml-2",
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "value": appointment.id,
        "checked": Array.isArray(_vm.selectedAppointmentIds) ? _vm._i(_vm.selectedAppointmentIds, appointment.id) > -1 : (_vm.selectedAppointmentIds)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.$emit("selected", index)
        },
        "change": function($event) {
          var $$a = _vm.selectedAppointmentIds,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = appointment.id,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.selectedAppointmentIds = $$a.concat([$$v]))
            } else {
              $$i > -1 && (_vm.selectedAppointmentIds = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.selectedAppointmentIds = $$c
          }
        }
      }
    }) : _vm._e()]), _vm._v(" "), (_vm.actions) ? _c('v-list-tile-action', [_c('v-menu', {
      staticClass: "pb-0",
      attrs: {
        "open-on-hover": "",
        "offset-y": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "slot": "activator",
        "icon": ""
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', {
      attrs: {
        "dense": ""
      }
    }, _vm._l((_vm.actions), function(item) {
      return _c('v-list-tile', {
        key: item.id,
        attrs: {
          "disabled": item.disableIf && item.disableIf(appointment)
        },
        on: {
          "click": function($event) {
            return _vm.actionClicked(item, appointment)
          }
        }
      }, [_c('v-list-tile-title', [_vm._v(_vm._s(item.title))])], 1)
    }), 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider', {
      staticClass: "mr-2",
      attrs: {
        "vertical": ""
      }
    }), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                          " + _vm._s(appointment.title || appointment.full_name)), (!_vm.isCompact) ? _c('small', [_vm._v(". " + _vm._s(_vm.dateformat(appointment.start_time)))]) : _vm._e(), _vm._v(" "), (!_vm.isCompact) ? _c('v-chip', {
      staticClass: "v-chip--x-small pa-0 text-center block",
      staticStyle: {
        "float": "right"
      },
      attrs: {
        "x-small": "",
        "label": "",
        "dark": "",
        "outline": "",
        "color": _vm.formatStatus(appointment.status).theme
      }
    }, [_vm._v("\n                            " + _vm._s(appointment.status_formatted) + "\n                          ")]) : _vm._e()], 1), _vm._v(" "), (_vm.isCompact) ? _c('v-list-tile-sub-title', {
      staticClass: "grey--text"
    }, [_vm._v("\n                          " + _vm._s(_vm.dateformat(appointment.start_time)) + "\n                          "), _c('v-chip', {
      staticClass: "v-chip--x-small pa-0 text-center block",
      attrs: {
        "x-small": "",
        "label": "",
        "dark": "",
        "outline": "",
        "color": _vm.formatStatus(appointment.status).theme
      }
    }, [_vm._v("\n                            " + _vm._s(appointment.status_formatted) + "\n                          ")])], 1) : _vm._e(), _vm._v(" "), (!_vm.isCompact) ? _c('v-list-tile-sub-title', {
      staticClass: "grey--text"
    }, [_vm._v("\n                          " + _vm._s(_vm.$tc('codessummary', appointment.codes.length, {
      n: appointment.codes.length
    })) + ".\n                          " + _vm._s(_vm.$tc('productsummary', appointment.lineitems.length, {
      n: appointment.lineitems.length
    })) + ".\n                        ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), (!_vm.isCompact) ? _c('v-spacer', {
      staticClass: "hidden-xs-only"
    }) : _vm._e(), _vm._v(" "), _c('v-btn', {
      staticClass: "hidden-xs",
      attrs: {
        "small": "",
        "icon": ""
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.launchInvoiceDetailsDialog(appointment, false)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("edit")])], 1), _vm._v(" "), (!_vm.isCompact) ? _c('v-flex', {
      staticClass: "text-xs-right hidden-xs-only"
    }, [_c('div', {
      staticClass: "v-list__tile__action-text"
    }, [_vm._v("Total")]), _vm._v("\n                    " + _vm._s(_vm.formatCurrency(appointment.currency, appointment.financials.final_price)) + "\n                  ")]) : _vm._e(), _vm._v(" "), (!_vm.isCompact) ? _c('v-flex', {
      staticClass: "text-xs-right mr-1 hidden-xs-only"
    }, [_c('div', {
      staticClass: "v-list__tile__action-text"
    }, [_vm._v("Payments")]), _vm._v("\n                    " + _vm._s(_vm.formatCurrency(appointment.currency, appointment.financials.payments_received)) + "\n                  ")]) : _vm._e(), _vm._v(" "), (!_vm.isCompact) ? _c('v-divider', {
      staticClass: "hidden-xs-only",
      attrs: {
        "vertical": ""
      }
    }) : _vm._e(), _vm._v(" "), _c('v-flex', {
      staticClass: "text-xs-right mr-2",
      attrs: {
        "xs3": "",
        "sm1": ""
      }
    }, [_c('div', {
      staticClass: "v-list__tile__action-text"
    }, [_vm._v("Outstanding")]), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.formatCurrency(appointment.currency, appointment.financials.final_due)))])])], 1)], 1), _vm._v(" "), _c('v-sheet', [_c('v-list', {
      attrs: {
        "dense": "",
        "subheader": ""
      }
    }, [_c('v-subheader', {
      staticClass: "overline"
    }, [_vm._v("\n                  Appointment Invoice details\n                  "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "small": "",
        "icon": ""
      },
      on: {
        "click": function($event) {
          return _vm.launchInvoiceDetailsDialog(appointment, false)
        }
      }
    }, [_c('v-icon', [_vm._v("edit")])], 1)], 1), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                      " + _vm._s(appointment.invoice_title || appointment.title) + "\n                    ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                      Title\n                    ")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (appointment.invoice_description) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                      " + _vm._s(appointment.invoice_description) + "\n                    ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                      Description\n                    ")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-divider'), _vm._v(" "), (appointment.product_name) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                      " + _vm._s(appointment.product_name) + "\n                    ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                      Appointment type\n                    ")])], 1)], 1) : _vm._e(), _vm._v(" "), (appointment.product_name) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                      " + _vm._s(appointment.status_formatted) + "\n                    ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                      Appointment status\n                    ")])], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), (appointment.codes && appointment.codes.length > 0) ? _c('v-sheet', [_c('appointment-code-list', {
      attrs: {
        "appointment": appointment,
        "title": "Diagnosis codes"
      },
      on: {
        "code:deleted": _vm.refresh
      }
    })], 1) : _vm._e(), _vm._v(" "), (appointment.total_price !== appointment.financials.sub_total) ? _c('v-sheet', {
      staticClass: "gray lighten-5"
    }, [_c('v-divider'), _vm._v(" "), _c('v-list', [
      [_c('v-list-tile', [_c('v-list-tile-content', [(appointment.discount_amount > 0) ? _c('v-list-tile-sub-title', [_vm._v("\n                      Less\n                      " + _vm._s(_vm.formatCurrency(appointment.currency, appointment.discount_amount)) + "\n                    ")]) : _vm._e(), _vm._v(" "), (appointment.tax_amount > 0) ? _c('v-list-tile-sub-title', [_vm._v("\n                      Tax\n                      " + _vm._s(_vm.formatCurrency(appointment.currency, appointment.tax_amount)) + "\n                    ")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action', [(appointment.tax_amount > 0) ? _c('v-list-tile-action-text', [_vm._v("After Tax")]) : _vm._e(), _vm._v("\n                    " + _vm._s(_vm.formatCurrency(appointment.currency, appointment.total_price)) + "\n                    "), _c('v-list-tile-action-text', [_vm._v("Total")])], 1)], 1)]
    ], 2)], 1) : _vm._e(), _vm._v(" "), (appointment.lineitems && appointment.lineitems.length > 0) ? _c('v-sheet', {
      staticClass: "mt-2"
    }, [_c('v-list', {
      attrs: {
        "dense": "",
        "subheader": ""
      }
    }, [_c('v-subheader', [_vm._v("\n                Other purchases")]), _vm._v(" "), _vm._l((appointment.lineitems), function(product) {
      return _c('v-list-tile', {
        key: product.id
      }, [_c('v-list-tile-action', {
        staticClass: "text-xs-center"
      }, [_c('v-avatar', [_vm._v(_vm._s(product.quantity))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                    " + _vm._s(product.description) + "\n                  ")]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                    @ " + _vm._s(_vm.formatCurrency(product.currency, product.unit_price)) + " each\n                  ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_vm._v("\n                  " + _vm._s(_vm.formatCurrency(product.currency, (product.quantity * product.unit_price))) + "\n                  "), _c('v-list-tile-action-text', [_vm._v("\n                    Total\n                  ")])], 1)], 1)
    }), _vm._v(" "), _c('v-list', [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title')], 1)], 1)], 1)], 2)], 1) : _vm._e(), _vm._v(" "), (appointment.payments && appointment.payments.length > 0) ? _c('v-sheet', [_c('payment-list', {
      attrs: {
        "appointment": appointment,
        "title": "Payments",
        "payments": appointment.payments
      },
      on: {
        "payment:deleted": _vm.refresh
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('v-divider', {
      staticClass: "mt-4"
    }), _vm._v(" "), _c('v-sheet', [_c('v-list', {
      staticClass: "grey lighten-4",
      attrs: {
        "dense": "",
        "subheader": ""
      }
    }, [_c('v-subheader', [_vm._v("Totals ")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _vm._l((_vm.subtotalList), function(item) {
      return [(appointment.financials[item.key] > 0) ? _c('v-list-tile', {
        key: item.key
      }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n                      " + _vm._s(item.text) + "\n                    ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_vm._v("\n                    " + _vm._s(_vm.formatCurrency(appointment.currency, appointment.financials[item.key])) + "\n                  ")])], 1) : _vm._e()]
    }), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
      staticClass: "headline"
    }, [_vm._v("\n                    Sub total\n                  ")])], 1), _vm._v(" "), _c('v-list-tile-action', {
      staticClass: "headline"
    }, [_vm._v("\n                  " + _vm._s(_vm.formatCurrency(appointment.currency, appointment.financials.final_due)) + "\n                ")])], 1)], 2)], 1)], 1)
  }), 1) : _c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-icon', {
    attrs: {
      "small": "",
      "color": "amber"
    }
  }, [_vm._v("warning")]), _vm._v("\n          No appointments found for\n          "), _c('strong', [_vm._v(_vm._s(_vm.clientFullname))]), _vm._v(" from\n          "), _c('strong', [_vm._v(_vm._s(_vm.dateformat(_vm.filterFromDate)) + "\n          "), (_vm.filterToDate) ? _c('span', [_vm._v(" to " + _vm._s(_vm.dateformat(_vm.filterToDate)))]) : _vm._e()])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.filterTouch++
      }
    }
  }, [_vm._v("Change date range")])], 1)], 1), _vm._v(" "), _c('v-divider')], 1), _vm._v(" "), (_vm.statement && _vm.statement.meta) ? _c('v-list', {
    staticClass: "mx-2",
    attrs: {
      "dense": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Grand total")]), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Total")])], 1), _vm._v(" "), _c('v-list-tile-action', [_vm._v(_vm._s(_vm.formatCurrency(_vm.defaultCurrency, _vm.statement.meta.price_before_tax)))])], 1), _vm._v(" "), (_vm.statement.meta.tax > 0) ? _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Tax")])], 1), _vm._v(" "), _c('v-list-tile-action', [_vm._v(_vm._s(_vm.formatCurrency(_vm.defaultCurrency, _vm.statement.meta.tax)))])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("Payments received")])], 1), _vm._v(" "), _c('v-list-tile-action', [_vm._v(_vm._s(_vm.formatCurrency(_vm.defaultCurrency, _vm.statement.meta.payments_received)))])], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list-tile', [_c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "headline"
  }, [_vm._v("Total due")])], 1), _vm._v(" "), _c('v-list-tile-action', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.formatCurrency(_vm.defaultCurrency, _vm.statement.meta.outstanding)))])], 1)], 1) : _vm._e()], 1), _vm._v(" "), (_vm.statement && _vm.statement.range) ? _c('v-footer', {
    staticClass: "pa-3 mt-4"
  }, [_c('div', [_vm._v("\n      Your first appointment with " + _vm._s(_vm.normalizedClient.first_name) + "\n      was on " + _vm._s(_vm.dateformat(_vm.statement.range.first_appointment_ever)) + "\n      (" + _vm._s(_vm.firstAppointmentAgo) + ").\n    ")]), _vm._v(" "), _c('v-spacer')], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.dialogs.invoiceSuccess),
      callback: function($$v) {
        _vm.$set(_vm.dialogs, "invoiceSuccess", $$v)
      },
      expression: "dialogs.invoiceSuccess"
    }
  }, [(_vm.newInvoice) ? _c('invoice-success', {
    attrs: {
      "client": _vm.normalizedClient
    },
    on: {
      "done": function($event) {
        _vm.dialogs.invoiceSuccess = false
      }
    },
    model: {
      value: (_vm.newInvoice),
      callback: function($$v) {
        _vm.newInvoice = $$v
      },
      expression: "newInvoice"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('bulk-actions', {
    attrs: {
      "client": _vm.normalizedClient,
      "selected-appointments": _vm.selectedAppointments
    },
    on: {
      "invoice:created": _vm.setNewInvoice,
      "payment:created": _vm.paymentAdded,
      "codes:created": _vm.codesAdded,
      "deselect": function($event) {
        _vm.selectAll = false;
        _vm.toggleSelectAll()
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1266b1e3","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/statement/index.vue
// module id = 1330
// module chunks = 9